import initBasicImageGallery from "../../utilities/basic-gallery";
import initOutsourcingManager from "./outsourcing-manager";
import initProductConfigurations from "./product-configurations";
import initProductSizeConfig from "./product-size-config";


/* 
This script manages product configuration forms that appear both on page load and dynamically via AJAX.
Using a MutationObserver, it watches for a form's specific class to appear in the DOM. Once found,
the script attaches all necessary event listeners. These events control:

    - Hiding and showing configuration options
    - Adding and managing outsourcing sections
    - Handling size and dimension inputs (including the swap and toggle features)
    - Initializing the image gallery for product previews
*/
// -------------------------------------------------------------
// MutationObserver Setup
// -------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {

    const observedNode = document.body;
    const watchedSelector = '.product-configurations';
    const observerConfig = {
        childList: true, // Observe direct children
        subtree: true    // Observe all descendants
    };

    const observerCallback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(node => {

                    if (node.nodeType === 1) {// Ensure the added node is an element and not just text
                        if (node.matches(watchedSelector)) {
                            attachFormEvents(node);
                        }

                        const descendants = node.querySelectorAll(watchedSelector);
                        descendants.forEach(el => {
                            attachFormEvents(el);
                        });
                    }
                });
            }
        }
    };

    const attachFormEvents = (node) => {
        const isLegacy = $('body').hasClass('legacy-master');
        const parentForm = node.closest('form');
        
        initProductConfigurations(parentForm); //'.product-configurations'
        initProductSizeConfig(parentForm); //'.sizeContainer'
        initOutsourcingManager(parentForm);// '#outsourcingContainer'

        if(isLegacy && typeof $.fn.simpleGal === 'function') {
            $('.feature-gallery ul').simpleGal({
                mainImage: ".feature img",
                thumbnails: ".img-trigger"
            });

            $('.feature-gallery ul').on('click', '.img-trigger', function () {
                var id = $(this).data('id');
                $('.feature a').attr('data-id', id);
            });

            if ($('body').hasClass('modal-open')) {
                $('.feature-gallery [data-toggle="modal"]').removeAttr('data-toggle');
            }
        } else {
            initBasicImageGallery(parentForm); //'.feature-gallery'
        }
    }

    const observer = new MutationObserver(observerCallback);
    observer.observe(observedNode, observerConfig);

    // for forms available on page load
    $(watchedSelector).each((_, el) => {
        attachFormEvents(el);
    });
});